<template>
  <div>
    <div v-for="(n, item) in empList" :key="item">
      <v-row
        v-if="employeeData[n].picture.length > 0"
        align="center"
        class="spacer mt-1"
        no-gutters
      >
        <v-col
          cols="6"
        >
          <v-avatar
            size="36px"
          >
            <img
              v-if="employeeData[n].empImge"
              alt="Avatar"
              :src="employeeData[n].empImge"
              @click="openDialogPreView(employeeData[n].picture[0].gallery)"
            >
            <v-avatar color="indigo" v-else>
              <v-icon dark>
                mdi-image-multiple
              </v-icon>
            </v-avatar>
          </v-avatar>
        </v-col>

        <v-col
        cols="6"
        >
          {{ employeeData[n].empFull_NameTH }}
        </v-col>
        </v-row>
    </div>
    <DialogPreView
      v-model="showDialogPreView"
      :gallery="prodGallery"
    />
  </div>
</template>

<script>
import DialogPreView from './DialogPreView.vue'
export default {
  name: 'ListStudio',
  components: {
    DialogPreView
  },
  props: {
    empList: {
      type: Array,
      required: true
    },
    employeeData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showDialogPreView: false,
      prodGallery: []
    }
  },
  methods: {
    async openDialogPreView (gallery) {
      this.prodGallery = gallery || []
      if (this.prodGallery.length > 0) {
        this.showDialogPreView = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/VelaStudio/ListStudio.vue